import { z } from 'zod';
import { optionalMongoIdString, optionalMongoIdOrNull } from './mongo-id.schema.js';

export const ScopeDocumentSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    title: z.string().min(1, 'form.validation.titleRequired'),
    version: z.string().optional().or(z.literal('')),
    geographicScope: z.string().optional().or(z.literal('')),
    organizationalScope: z.string().optional().or(z.literal('')),
    technologicalScope: z.string().optional().or(z.literal('')),
    exclusions: z.string().optional().or(z.literal('')),
    exclusionJustification: z.string().optional().or(z.literal('')),
    linkedDocumentId: optionalMongoIdString,
    approvedBy: z.string().optional().or(z.literal('')),
    approvedDate: z.string().optional().or(z.literal('')),
    reviewDate: z.string().optional().or(z.literal('')),
    status: z.enum(['draft', 'approved', 'under-review', 'archived']).default('draft'),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateScopeDocumentSchema = ScopeDocumentSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true
});
export const UpdateScopeDocumentSchema = CreateScopeDocumentSchema.partial().extend({
    linkedDocumentId: optionalMongoIdOrNull
});
